import axios from 'axios'
import { alert } from "devextreme/ui/dialog"
import * as Enumerable from "linq-es5"
const baseUri = "WebApi.asmx/api/modulTypeService";
const store = {};
const mutations = {
    SET_DETAIL(state, posts) {
        if (posts.success == true) {
            state.modulTypeDetail = posts.data;
            state.modulTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SAVE_MODULTYPE_DETAIL(state, posts) {
        if (posts.success == true) {
            state.modulTypeDetailChanged = false;
        }
        else {
            alert(posts.errorMessage);
        }
    },
    SET_MODULTYPE_ATTRIBUTE_STATUS_LIST(state, posts) {
        state.modulTypeAttributeStatusList = posts;
        state.modulTypeAttributeStatusListIsLoading = false;
    },
    SET_MODULTYPE_ATTRIBUTE_STATUS_ENUM(state, posts) {
        posts.push({
            MseId: null,
            MseName: "-",
            MseShortcut: ""
        });
        state.modulTypeAttributeStatusEnum = posts;
        state.modulTypeAttributeStatusEnumIsLoading = false;
    },
    SET_MTY_STATUS_LIST(state, posts) {
        state.modulTypeStatusList = posts;
        state.modulTypeStatusListIsLoading = false;
    },
    SET_MTY_ATTRIBUTE_LIST(state, posts) {
        state.modulTypeAttributeList = posts;
        state.modulTypeAttributeListIsLoading = false;
    },
    SET_MODULTYPE_ATTRIBUTE_STATUS_DATA(state, posts) {
        state.modulTypeStatusList = posts.statusList;
        state.modulTypeStatusListIsLoading = false;
        state.modulTypeAttributeList = posts.attributeList;
        state.modulTypeAttributeListIsLoading = false;
        state.modulTypeAttributeStatusList = posts.modulTypeAttributeStatusList;
        state.modulTypeAttributeStatusListIsLoading = false;
        posts.modulTypeAttributeStatusEnum.push({
            MseId: null,
            MseName: "-",
            MseShortcut: ""
        });
        state.modulTypeAttributeStatusEnum = posts.modulTypeAttributeStatusEnum;
        state.modulTypeAttributeStatusEnumIsLoading = false;

        var pivot = posts.attributeList.map(m => {
            m.RegNameWithPos = ((1000 + (m.RegPosition ? m.RegPosition : 0)) + '_').substring(1) + m.RegName;
            return m;
        });
        pivot.forEach(m => {
            posts.statusList.forEach(s => {
                var val = null;
                if (posts.modulTypeAttributeStatusList) {
                    var entry = posts.modulTypeAttributeStatusList.find(g => g.StatusId == s.StatusID && g.MatId == m.MatId);
                    if (entry) {
                        val = entry.MsdId;
                    }
                }
                m["Sta" + s.StatusID] = val;
            });
        });
        //console.log(pivot)
        var dynColumns = Enumerable.asEnumerable(posts.statusList)
            .GroupBy(m => m.TtyName)
            .Select(m => {
                return {
                    caption: m.key,
                    columns: m.map(s => {
                        return {
                            dataField: 'Sta' + s.StatusID,
                            caption: s.StatusName,
                            headerCellTemplate: "headerTemplate",
                            cssClass: "tsDynHeader",
                            dataType: 'number',
                            alignment: 'center',
                            lookup: {
                                dataSource: posts.modulTypeAttributeStatusEnum,
                                valueExpr: "MseId",
                                displayExpr: "MseShortcut"
                            }
                        };
                    })
                };
            })
            .ToArray();


        var beginColumns = [{
            dataField: "RegNameWithPos",
            caption: 'Region',
            groupIndex: 1,
            width: 250,
            fixed: true,
            fixedPosition: 'left',
        }, {
            dataField: "Caption",
            caption: 'Feld',
            width: 250,
            fixed: true,
            fixedPosition: 'left',
        }];
        state.masColumns = [...beginColumns, ...dynColumns];

        state.masPivot = pivot;
        state.masPivotIsLoading = false;
        state.masPivotChanged = false;


    },
    GET_MODULTYPE_LIST(state, posts) {
        state.modulTypeList = posts.data;
        state.isLoading = false;
    },
    GET_MODULTYPE_SIMPLE_LIST(state, posts) {
        state.modulTypeSimpleList = posts.data;
        state.isLoading = false;
    },
};
const state = {
    modulTypeAttributeStatusListIsLoading: false,
    modulTypeAttributeStatusList: [],
    modulTypeAttributeStatusEnumIsLoading: false,
    modulTypeAttributeStatusEnum: [],
    modulTypeDetail: {},
    modulTypeDetailChanged: false,
    modulTypeAttributeList: false,
    modulTypeAttributeListIsLoading: [],
    modulTypeStatusListIsLoading: false,
    modulTypeSimpleList: [],
    modulTypeStatusList: [],
    modulTypeList: [],
    isLoading: false,
    DxExport: [],
    masPivotChanged: false,
    masColumns: [],
    masPivotIsLoading: false,
    accessRightManagementVersionList: [{ Id: 1, Name: '1 - Legacy' }, { Id: 2, Name: '2' }]
};

const getters = {
    getMasDataFromPivotData() {
        var result = [];
        state.masPivot.forEach(m => {
            state.modulTypeStatusList.forEach(s => {
                var val = m["Sta" + s.StatusID];
                if (val != null) {
                    var rec = { MatId: m.MatId, StatusId: s.StatusID, MsdId: val };
                    result.push(rec);
                }
            });
        });
        console.log(result);
        return result;
    }
};
const actions = {
    getMtyStatusList({ commit }, data) {
        state.modulTypeStatusListIsLoading = true;
        var formData = new FormData();
        formData.append("mtyId", data.mtyId);
        axios
            .get(baseUri + '/GetStatusList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MTY_STATUS_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getModulTypeAttributeList({ commit }, data) {
        state.modulTypeStatusListIsLoading = true;
        var formData = new FormData();
        formData.append("mtyId", data.mtyId);
        axios
            .get(baseUri + '/GetAttributeList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MTY_ATTRIBUTE_LIST', res.data.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getModulTypeDetail({ commit }, data) {
        var formData = new FormData();
        formData.append("mtyId", data.mtyId);
        axios
            .post(baseUri + '/GetDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_DETAIL', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getModulTypeAttributeStatusList({ commit }, data) {
        var formData = new FormData();
        formData.append("mtyId", data.mtyId);
        axios
            .post(baseUri + '/GetModulTypeAttributeStatusList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MODULTYPE_ATTRIBUTE_STATUS_LIST', res.data);
                } else {
                    alert(res.data.errorMessage);
                }

            });
    },
    getModulTypeAttributeStatusEnum({ commit }, data) {
        var formData = new FormData();
        formData.append("mtyId", data.mtyId);
        axios
            .post(baseUri + '/GetModulTypeAttributeStatusEnumList', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MODULTYPE_ATTRIBUTE_STATUS_ENUM', res.data);
                } else {
                    alert(res.data.errorMessage);
                }

            });
    },
    getModulTypeAttributeStatusData({ commit }, data) {
        this.masPivotIsLoading = true;
        var formData = new FormData();
        formData.append("mtyId", data.mtyId);
        axios
            .post(baseUri + '/GetModulTypeAttributeStatusData', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SET_MODULTYPE_ATTRIBUTE_STATUS_DATA', res.data);
                } else {
                    alert(res.data.errorMessage);
                }

            });
    },
    saveModulTypeDetail({ commit }) {
        var formData = new FormData();
        formData.append("data", JSON.stringify(state.modulTypeDetail));
        formData.append("mas", JSON.stringify(getters.getMasDataFromPivotData()));
        axios
            .post(baseUri + '/SaveDetail', formData)
            .then(res => {
                if (res.data.success == true) {
                    commit('SAVE_MODULTYPE_DETAIL', res.data);
                } else {
                    alert("An error occured while updating: " + res.data.errorMessage);
                }

            });
    },
    getModulTypeList({ commit }) {
        state.isLoading = true;
        axios
            .get(baseUri + '/GetList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_MODULTYPE_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
    getModulTypeSimpleList({ commit }) {
        state.isLoading = true;
        axios
            .get(baseUri + '/GetSimpleList')
            .then(res => {
                if (res.data.success == true) {
                    commit('GET_MODULTYPE_SIMPLE_LIST', res.data);
                }
                else {
                    alert(res.data.errorMessage);
                }
            });
    },
};


export default {
    state,
    store,
    mutations,
    getters,
    actions
}